import React from 'react';
import PropTypes from 'prop-types';

import './Button.css';

export default function Button(props) {
  const {
    cName, onClick, label, disabled,
  } = props;
  const handleClick = disabled ? undefined : onClick;
  return (
    <div
      className={`${cName} button${disabled ? ' button-disabled' : ''}`}
      onClick={handleClick}
      onKeyUp={handleClick}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
    >
      {label}
    </div>
  );
}

Button.propTypes = {
  cName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  cName: '',
  label: '',
  disabled: false,
};
